// SAGE3 Generated from apps.json file

import { name as AIPaneName, init as defaultAIPane } from './apps/AIPane';
import { name as AssetLinkName, init as defaultAssetLink } from './apps/AssetLink';
import { name as BoardLinkName, init as defaultBoardLink } from './apps/BoardLink';
import { name as CSVViewerName, init as defaultCSVViewer } from './apps/CSVViewer';
import { name as CalculatorName, init as defaultCalculator } from './apps/Calculator';
import { name as ChartGeneratorName, init as defaultChartGenerator } from './apps/ChartGenerator';
import { name as ChatName, init as defaultChat } from './apps/Chat';
import { name as ClockName, init as defaultClock } from './apps/Clock';
import { name as CobrowseName, init as defaultCobrowse } from './apps/Cobrowse';
import { name as CodeEditorName, init as defaultCodeEditor } from './apps/CodeEditor';
import { name as CounterName, init as defaultCounter } from './apps/Counter';
import { name as DeepZoomImageName, init as defaultDeepZoomImage } from './apps/DeepZoomImage';
import { name as DrawingName, init as defaultDrawing } from './apps/Drawing';
import { name as EChartsViewerName, init as defaultEChartsViewer } from './apps/EChartsViewer';
import { name as FrameName, init as defaultFrame } from './apps/Frame';
import { name as GLTFViewerName, init as defaultGLTFViewer } from './apps/GLTFViewer';
import { name as HCDPName, init as defaultHCDP } from './apps/HCDP';
import { name as IFrameName, init as defaultIFrame } from './apps/IFrame';
import { name as ImageViewerName, init as defaultImageViewer } from './apps/ImageViewer';
import { name as JupyterLabName, init as defaultJupyterLab } from './apps/JupyterLab';
import { name as LeafLetName, init as defaultLeafLet } from './apps/LeafLet';
import { name as LinkerName, init as defaultLinker } from './apps/Linker';
import { name as MapName, init as defaultMap } from './apps/Map';
import { name as MermaidName, init as defaultMermaid } from './apps/Mermaid';
import { name as NotepadName, init as defaultNotepad } from './apps/Notepad';
import { name as PDFResultName, init as defaultPDFResult } from './apps/PDFResult';
import { name as PDFViewerName, init as defaultPDFViewer } from './apps/PDFViewer';
import { name as PluginAppName, init as defaultPluginApp } from './apps/PluginApp';
import { name as PollName, init as defaultPoll } from './apps/Poll';
import { name as RTCChatName, init as defaultRTCChat } from './apps/RTCChat';
import { name as SageCellName, init as defaultSageCell } from './apps/SageCell';
import { name as SensorOverviewName, init as defaultSensorOverview } from './apps/SensorOverview';
import { name as SlideCreatorName, init as defaultSlideCreator } from './apps/SlideCreator';
import { name as StickieName, init as defaultStickie } from './apps/Stickie';
import { name as TimerName, init as defaultTimer } from './apps/Timer';
import { name as TwilioScreenshareName, init as defaultTwilioScreenshare } from './apps/TwilioScreenshare';
import { name as VegaLiteName, init as defaultVegaLite } from './apps/VegaLite';
import { name as VegaLiteViewerName, init as defaultVegaLiteViewer } from './apps/VegaLiteViewer';
import { name as VideoViewerName, init as defaultVideoViewer } from './apps/VideoViewer';
import { name as WebpageLinkName, init as defaultWebpageLink } from './apps/WebpageLink';
import { name as WebviewName, init as defaultWebview } from './apps/Webview';

export const initialValues = {
  [AIPaneName]: defaultAIPane,
  [AssetLinkName]: defaultAssetLink,
  [BoardLinkName]: defaultBoardLink,
  [CSVViewerName]: defaultCSVViewer,
  [CalculatorName]: defaultCalculator,
  [ChartGeneratorName]: defaultChartGenerator,
  [ChatName]: defaultChat,
  [ClockName]: defaultClock,
  [CobrowseName]: defaultCobrowse,
  [CodeEditorName]: defaultCodeEditor,
  [CounterName]: defaultCounter,
  [DeepZoomImageName]: defaultDeepZoomImage,
  [DrawingName]: defaultDrawing,
  [EChartsViewerName]: defaultEChartsViewer,
  [FrameName]: defaultFrame,
  [GLTFViewerName]: defaultGLTFViewer,
  [HCDPName]: defaultHCDP,
  [IFrameName]: defaultIFrame,
  [ImageViewerName]: defaultImageViewer,
  [JupyterLabName]: defaultJupyterLab,
  [LeafLetName]: defaultLeafLet,
  [LinkerName]: defaultLinker,
  [MapName]: defaultMap,
  [MermaidName]: defaultMermaid,
  [NotepadName]: defaultNotepad,
  [PDFResultName]: defaultPDFResult,
  [PDFViewerName]: defaultPDFViewer,
  [PluginAppName]: defaultPluginApp,
  [PollName]: defaultPoll,
  [RTCChatName]: defaultRTCChat,
  [SageCellName]: defaultSageCell,
  [SensorOverviewName]: defaultSensorOverview,
  [SlideCreatorName]: defaultSlideCreator,
  [StickieName]: defaultStickie,
  [TimerName]: defaultTimer,
  [TwilioScreenshareName]: defaultTwilioScreenshare,
  [VegaLiteName]: defaultVegaLite,
  [VegaLiteViewerName]: defaultVegaLiteViewer,
  [VideoViewerName]: defaultVideoViewer,
  [WebpageLinkName]: defaultWebpageLink,
  [WebviewName]: defaultWebview,
};

